


































import { Component, Inject, Prop, Vue } from 'vue-property-decorator';
import Icon from '@/main-components/common/Icon.vue';
import MainButton from '@/main-components/common/MainButton.vue';
import {
  PreCollection,
  PreCollectionContentType,
} from '@/resource/pre-collection/pre-collection.model';
import PurchaseStore, {
  PurchaseStoreInterface,
} from '@/resource/purchase/purchase.store';

@Component({
  components: {
    Icon,
    MainButton,
  },
})
export default class PreCollectionPreviewOverlay extends Vue {
  @Prop({ default: true })
  isLoggedin!: boolean;

  @Prop({ required: true })
  currentPreCollection!: PreCollection;

  @Prop({ required: true })
  description: string;

  @Prop({ required: true })
  btnLabel: string;

  @Prop({ default: false })
  isPremiumStatus: boolean;

  @Inject('colorBrandDarkPrimary')
  colorBrandDarkPrimary!: string;

  @Inject('openPremiumPlanModal')
  openPremiumPlanModal!: () => void;

  @Inject('openRegisterModal')
  openRegisterModal!: () => void;

  purchaseStore: PurchaseStoreInterface = PurchaseStore;

  async createPurchase() {
    await this.purchaseStore.createPurchase(this.currentPreCollection.uuid);
    window.location.reload();
  }

  onBecomePremiumClicked() {
    if (!this.isLoggedin) {
      this.$sendMpEvent({ event: this.$mp_value.PremadePaperRegister });
      this.openRegisterModal && this.openRegisterModal();
      return;
    }

    if (this.currentPreCollection.course) {
      this.$sendMpEvent({
        event: this.$mp_value.CourseBecomePremium,
        properties: {
          uuid: this.currentPreCollection.uuid,
          name: this.currentPreCollection.name,
          form: this.currentPreCollection.form,
          type: this.currentPreCollection.type,
          year: this.currentPreCollection.year,
          subjectUuid: this.currentPreCollection.subject.uuid,
          isPremium: this.currentPreCollection.isPremium,
          isMainButton: false,
          contentType: PreCollectionContentType.Course,
        },
      });
    } else {
      this.$sendMpEvent({
        event: this.$mp_value.PremadePaperLimitHit,
        properties: {
          uuid: this.currentPreCollection.uuid,
          name: this.currentPreCollection.name,
          form: this.currentPreCollection.form,
          type: this.currentPreCollection.type,
          year: this.currentPreCollection.year,
          subjectUuid: this.currentPreCollection.subject.uuid,
          isPremium: this.currentPreCollection.isPremium,
          isMainButton: false,
          contentType: this.currentPreCollection.course
            ? PreCollectionContentType.Course
            : this.currentPreCollection.pdfLink
            ? PreCollectionContentType.Pdf
            : this.currentPreCollection.collection
            ? PreCollectionContentType.Collection
            : PreCollectionContentType.PaperGenerated,
        },
      });
    }

    this.openPremiumPlanModal && this.openPremiumPlanModal();
  }
}
